import type { CommonDataState } from './CommonData.types';

export enum CommonDataKeys {
  IS_ASSIGNING = 'isAssigning',
  REVIEWERS = 'reviewers',
}

export const initialState: CommonDataState = {
  [CommonDataKeys.IS_ASSIGNING]: false,
  [CommonDataKeys.REVIEWERS]: [],
};
